import { createCachedSelector, path, defaultKeySelector } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { nodeStoreSelector } from '../node.selector';

export const selectedNodeSelector = createCachedSelector(
  [
    path(nodeStoreSelector).selected(),
  ],
  (selectedNode) => {
    return selectedNode;
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
